"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syntheticsHealthMeasurements = void 0;
var _unitEnums = require("../../query/unitEnums");
var _synthDimensions = require("./synthDimensions");
const syntheticsHealthMeasurements = exports.syntheticsHealthMeasurements = [{
  measurement: '/synthetics/ping',
  displayName: 'Synthetics',
  storage: {
    Metrics: {
      ping_latency_avg: {
        Type: 'int',
        Label: 'Latency',
        Column: 'INT02',
        Unit: 'duration:microseconds',
        Rollup: true
      },
      ping_latency_health: {
        Type: 'int',
        Label: 'Latency Health',
        Column: 'INT07',
        Unit: 'health',
        Values: _unitEnums.HEALTH_VALUES,
        HealthyValue: _unitEnums.HEALTHY_HEALTH_VALUE,
        Rollup: false
      },
      ping_jitter_avg: {
        Type: 'int',
        Label: 'Jitter',
        Column: 'INT04',
        Unit: 'duration:microseconds',
        Rollup: true
      },
      ping_jitter_health: {
        Type: 'int',
        Label: 'Jitter Health',
        Column: 'INT09',
        Unit: 'health',
        Values: _unitEnums.HEALTH_VALUES,
        HealthyValue: _unitEnums.HEALTHY_HEALTH_VALUE,
        Rollup: false
      },
      ping_packet_loss_pct: {
        Type: 'float',
        Label: 'Packet Loss (%)',
        Column: 'km_float000',
        Unit: 'percent',
        Rollup: true
      },
      ping_packet_loss_health: {
        Type: 'int',
        Label: 'Packet Loss Health',
        Column: 'INT08',
        Unit: 'health',
        Values: _unitEnums.HEALTH_VALUES,
        HealthyValue: _unitEnums.HEALTHY_HEALTH_VALUE,
        Rollup: false
      }
    },
    Dimensions: {
      ...(0, _synthDimensions.getCommonSyntheticHealthDimensionNames)({
        exclude: ['task_dns_resolver', 'task_dns_target_hostname']
      })
    }
  }
}, {
  measurement: '/synthetics/dns',
  displayName: 'Synthetics',
  storage: {
    Metrics: {
      dns_latency_avg: {
        Type: 'int',
        Label: 'DNS Resolution Latency',
        Column: 'INT02',
        Unit: 'duration:microseconds',
        Rollup: true
      },
      dns_latency_health: {
        Type: 'int',
        Label: 'DNS Resolution Latency Health',
        Column: 'INT07',
        Unit: 'health',
        Values: _unitEnums.HEALTH_VALUES,
        HealthyValue: _unitEnums.HEALTHY_HEALTH_VALUE,
        Rollup: false
      },
      dns_code: {
        Type: 'int',
        Label: 'DNS Response Code',
        Column: 'INT06',
        Unit: 'dns_code',
        Values: _unitEnums.DNS_CODE_VALUES,
        Rollup: false
      }
    },
    Dimensions: {
      ...(0, _synthDimensions.getCommonSyntheticHealthDimensionNames)({
        // dns tasks will never have dst agents
        exclude: ['dst_address', 'dst_agent', 'dst_agent_site_id', 'dst_agent_asn', 'dst_agent_ip', 'dst_agent_country', 'dst_task_target']
      })
    }
  }
}, {
  measurement: '/synthetics/throughput',
  displayName: 'Synthetics',
  storage: {
    Metrics: {
      throughput_bandwidth_avg: {
        Type: 'bytes',
        Label: 'Bandwidth',
        Column: 'km_float001',
        Unit: 'Mbits/s',
        Rollup: true
      }
    },
    Dimensions: {
      // throughput tasks will never have dns dimensions
      ...(0, _synthDimensions.getCommonSyntheticHealthDimensionNames)({
        exclude: ['task_dns_resolver', 'task_dns_target_hostname']
      })
    }
  }
}, {
  measurement: '/synthetics/http',
  displayName: 'Synthetics',
  storage: {
    Metrics: {
      http_latency_avg: {
        Type: 'int',
        Label: 'Latency (ttlb)',
        Column: 'INT02',
        Unit: 'duration:microseconds',
        Rollup: true
      },
      http_latency_health: {
        Type: 'int',
        Label: 'Latency Health',
        Column: 'INT07',
        Unit: 'health',
        Values: _unitEnums.HEALTH_VALUES,
        HealthyValue: _unitEnums.HEALTHY_HEALTH_VALUE,
        Rollup: false
      },
      http_status_code: {
        Type: 'int',
        Label: 'HTTP Status Code',
        Column: 'INT06',
        Unit: 'http_status_code',
        Values: _unitEnums.HTTP_STATUS_CODE_VALUES,
        Rollup: false
      },
      http_response_size: {
        Type: 'int',
        Label: 'HTTP Response Size',
        Column: 'INT05',
        Unit: 'bytes',
        Rollup: true
      }
    },
    Dimensions: {
      ...(0, _synthDimensions.getCommonSyntheticHealthDimensionNames)({
        // http tasks will never have dns dimensions or dst agents
        exclude: ['dst_agent', 'dst_agent_site_id', 'dst_agent_asn', 'dst_agent_ip', 'dst_agent_country', 'task_dns_resolver', 'task_dns_target_hostname']
      })
    }
  }
}, {
  measurement: '/synthetics/pageload',
  displayName: 'Synthetics',
  storage: {
    Metrics: {
      pageload_latency_avg: {
        Type: 'int',
        Label: 'Latency (ttlb)',
        Column: 'INT02',
        Unit: 'duration:microseconds',
        Rollup: true
      },
      pageload_latency_health: {
        Type: 'int',
        Label: 'Latency Health',
        Column: 'INT07',
        Unit: 'health',
        Values: _unitEnums.HEALTH_VALUES,
        HealthyValue: _unitEnums.HEALTHY_HEALTH_VALUE,
        Rollup: false
      },
      pageload_status_code: {
        Type: 'int',
        Label: 'HTTP Status Code',
        Column: 'INT06',
        Unit: 'http_status_code',
        Values: _unitEnums.HTTP_STATUS_CODE_VALUES,
        Rollup: false
      },
      pageload_response_size: {
        Type: 'int',
        Label: 'HTTP Response Size',
        Column: 'INT05',
        Unit: 'bytes',
        Rollup: true
      }
    },
    Dimensions: {
      ...(0, _synthDimensions.getCommonSyntheticHealthDimensionNames)({
        // pageload tasks will never have dns dimensions or dst agents
        exclude: ['dst_agent', 'dst_agent_site_id', 'dst_agent_asn', 'dst_agent_ip', 'dst_agent_country', 'task_dns_resolver', 'task_dns_target_hostname']
      })
    }
  }
}];